var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08768 14.1558H10.1432C10.8111 14.1558 11.4517 13.8904 11.924 13.4181C12.3963 12.9459 12.6616 12.3053 12.6616 11.6374V7.65841C12.6618 6.99059 12.3968 6.35002 11.9248 5.87758L7.62992 1.582C7.39605 1.34815 7.11841 1.16266 6.81286 1.03612C6.5073 0.909577 6.17981 0.844459 5.84909 0.844482H4.08768C3.41978 0.844482 2.77923 1.10981 2.30694 1.58209C1.83466 2.05437 1.56934 2.69492 1.56934 3.36283V11.6374C1.56934 12.3053 1.83466 12.9459 2.30694 13.4181C2.77923 13.8904 3.41978 14.1558 4.08768 14.1558Z",
    stroke: "#B00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89062 1.10352V5.17604C6.89062 5.55771 7.04224 5.92374 7.31212 6.19361C7.58199 6.46349 7.94802 6.6151 8.32968 6.6151H12.4036",
    stroke: "#B00000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.69727 10.7379V10.0184M3.69727 10.0184V8.57935H4.41679C4.60762 8.57935 4.79064 8.65515 4.92558 8.79009C5.06051 8.92503 5.13632 9.10804 5.13632 9.29887C5.13632 9.4897 5.06051 9.67272 4.92558 9.80766C4.79064 9.94259 4.60762 10.0184 4.41679 10.0184H3.69727ZM9.45349 10.7379V9.83852M9.45349 9.83852V8.57935H10.5328M9.45349 9.83852H10.5328M6.57538 10.7379V8.57935H6.93514C7.22139 8.57935 7.49591 8.69306 7.69832 8.89546C7.90072 9.09787 8.01443 9.37239 8.01443 9.65864C8.01443 9.94488 7.90072 10.2194 7.69832 10.4218C7.49591 10.6242 7.22139 10.7379 6.93514 10.7379H6.57538Z",
    stroke: "#B00000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7014bdddd717441cff8003bd93418e69.svg";
export { ForwardRef as ReactComponent };